export default "__VITE_ASSET__565794ac__"